import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";

import { useDispatch } from "react-redux";
import * as uiActions from "store/actions/uiActions";

const DURATION = 5000;
const SnackBarContent = ({
  id,
  message,
  actionButton,
  status = "success",
  autoHide = true
}) => {
  const dispatch = useDispatch();
  const timerAutoHide = React.useRef();

  const handleClose = useCallback(() => {
    clearTimeout(timerAutoHide.current);
    dispatch(uiActions.removeSnackbar(id));
  }, [dispatch, id]);

  const startTimer = useCallback(() => {
    if (!autoHide) {
      return;
    }

    if (timerAutoHide.current) {
      clearTimeout(timerAutoHide.current);
    }
    timerAutoHide.current = setTimeout(handleClose, DURATION);
  }, [autoHide, handleClose]);

  useEffect(() => {
    startTimer();
    return () => {
      clearTimeout(timerAutoHide.current);
    };
  }, [startTimer]);

  const cancelAutoHide = () => {
    clearTimeout(timerAutoHide.current);
  };
  const contentClassName = [
    "snackbars__content",
    `snackbars_${status}__content`,
    "d-flex",
    "align-items-center",
    "justify-content-between"
  ].join(" ");

  return (
    <div
      className={contentClassName}
      onMouseLeave={startTimer}
      onMouseEnter={cancelAutoHide}
    >
      <span className="pe-3">{message}</span>
      <div className="d-flex align-items-center">
        {actionButton && (
          <div
            className="snackbars__action"
            style={{ width: "max-content" }}
            onClick={actionButton.func}
          >
            {actionButton.title}
          </div>
        )}
        <div className="snackbars__close" onClick={handleClose}></div>
      </div>
    </div>
  );
};

SnackBarContent.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  message: PropTypes.string,
  actionButton: PropTypes.object,
  status: PropTypes.string,
  autoHide: PropTypes.bool
};

export default SnackBarContent;
